<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/andon/reportingLevel/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('yichangleixingmingcheng')">
						<el-select filterable :clearable="true" v-model="yt.conditions.exceptionTypeId">
							<el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhuangtai')">
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('youxiao')" :value="1"></el-option>
							<el-option :label="$t('shixiao')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_andon_management_reporting_level_create')" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()">
				</el-button>
			</template>
			<!-- 自定义某个字段 -->
			<template #yijihuibaoren="scope">
				<!-- 一级汇报人 -->
				<template>
					<span>{{scope.row.levelFirstReporter | getFirstText}}</span>
				</template>
			</template>
			<template #erjihuibaoren="scope">
				<!-- 二级汇报人 -->
				<template>
					<span>{{scope.row.levelSecondReporter | getSecondText}}</span>
				</template>
			</template>
			<template #sanjihuibaoren="scope">
				<!-- 三级汇报人 -->
				<template>
					<span>{{scope.row.levelThirdReporter | getThirdText}}</span>
				</template>
			</template>

			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)" v-if="utils.checkPower('web_andon_management_reporting_level_update')">
							{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_andon_management_reporting_level_delete')"
							@click="yt.remove(scope.row,'/web/andon/reportingLevel/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<div class="dialog-scroller">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('yichangleixingmingcheng')" required>
							<el-select filterable :clearable="true" v-model="yt.editObj.exceptionTypeId">
								<el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('yijihuibaoren')" required>
							<yi_cross_select multiple :component="'web_system_user_list'"
								:ids.sync="yt.editObj.levelFirstReporterUserIds">
							</yi_cross_select>
						</el-form-item>
						<el-form-item :label="$t('querenchaoshixiangerjihuibao (fen)')">
							<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
								v-model="yt.editObj.secondLevelConfirmationTimeout"></el-input>
						</el-form-item>
						<el-form-item :label="$t('chulichaoshixiangerjihuibao (fen)')">
							<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
								v-model="yt.editObj.secondLevelProcessingTimeout"></el-input>
						</el-form-item>
						<el-form-item :label="$t('erjihuibaoren')">
							<yi_cross_select multiple :component="'web_system_user_list'"
								:ids.sync="yt.editObj.levelSecondReporterUserIds">
							</yi_cross_select>
						</el-form-item>
						<el-form-item :label="$t('querenchaoshixiangsanjihuibao (fen)')">
							<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
								v-model="yt.editObj.thirdLevelConfirmationTimeout"></el-input>
						</el-form-item>
						<el-form-item :label="$t('chulichaoshixiangsanjihuibao (fen)')">
							<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
								v-model="yt.editObj.thirdLevelProcessingTimeout"></el-input>
						</el-form-item>
						<el-form-item :label="$t('sanjihuibaoren')">
							<yi_cross_select multiple :component="'web_system_user_list'"
								:ids.sync="yt.editObj.levelThirdReporterUserIds">
							</yi_cross_select>
						</el-form-item>
						<el-form-item :label="$t('zhuangtai')" required>
							<el-select v-model="yt.editObj.status" @change="$forceUpdate()">
								<el-option :label="$t('youxiao')" :value="1"></el-option>
								<el-option :label="$t('shixiao')" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/andon/reportingLevel/create', null, fetchData)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>

			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('yichangleixingmingcheng')" required class="noborder">
						<el-select disabled filterable :clearable="true" v-model="yt.editObj.exceptionTypeId">
							<el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('yijihuibaoren')" required>
						<yi_cross_select multiple :component="'web_system_user_list'"
							:ids.sync="yt.editObj.levelFirstReporterUserIds">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('querenchaoshixiangerjihuibao (fen)')">
						<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
							v-model="yt.editObj.secondLevelConfirmationTimeout"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chulichaoshixiangerjihuibao (fen)')">
						<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
							v-model="yt.editObj.secondLevelProcessingTimeout"></el-input>
					</el-form-item>
					<el-form-item :label="$t('erjihuibaoren')">
						<yi_cross_select multiple :component="'web_system_user_list'"
							:ids.sync="yt.editObj.levelSecondReporterUserIds">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('querenchaoshixiangsanjihuibao (fen)')">
						<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
							v-model="yt.editObj.thirdLevelConfirmationTimeout"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chulichaoshixiangsanjihuibao (fen)')">
						<el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
							v-model="yt.editObj.thirdLevelProcessingTimeout"></el-input>
					</el-form-item>
					<el-form-item :label="$t('sanjihuibaoren')">
						<yi_cross_select multiple :component="'web_system_user_list'"
							:ids.sync="yt.editObj.levelThirdReporterUserIds">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('zhuangtai')" required>
						<el-select v-model="yt.editObj.status" @change="$forceUpdate()">
							<el-option :label="$t('youxiao')" :value="1"></el-option>
							<el-option :label="$t('shixiao')" :value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/andon/reportingLevel/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_andon_management_reporting_level_list',
		components: {

		},
		data() {
			return {
				exceptionTypeList: [],
				columns: [{
						label: 'yichangleixingmingcheng',
						prop: 'exceptionType.name',
						width: 130
					}, {
						label: 'yijihuibaoren',
						type: 'slot',
						width: 130
					},
					{
						label: 'querenchaoshixiangerjihuibao (fen)',
						prop: 'secondLevelConfirmationTimeout',
						width: 130
					},
					{
						label: 'chulichaoshixiangerjihuibao (fen)',
						prop: 'secondLevelProcessingTimeout',
						width: 130
					}, {
						label: 'erjihuibaoren',
						type: 'slot',
					}, {
						label: 'querenchaoshixiangsanjihuibao (fen)',
						prop: 'thirdLevelConfirmationTimeout',
						width: 130
					}, {
						label: 'chulichaoshixiangsanjihuibao (fen)',
						prop: 'thirdLevelProcessingTimeout',
						width: 130
					}, {
						label: 'sanjihuibaoren',
						type: 'slot',
						width: 130
					}, {
						label: 'zhuangtai',
						prop: 'status',
						type: 'tag',
						tags: {
							0: {
								color: '#909399',
								text: this.$t('shixiao')

							},
							1: {
								color: '#419FFF',
								text: this.$t('youxiao')
							}
						},
					}, {
						label: 'caozuo',
						type: 'slot',
						width: 230,
						fixed: 'right'
					}
				]
			};
		},

		created() {
			setTimeout(() => {
				this.getExceptionType();
				this.yt.conditions = {
					orderBy: 'createTime desc',
				}
				this.yt.get(1)
			}, 300)
		},
		filters: {
			getFirstText(value) {
				return value.map(item => {
					return item.userInfo.nickname
				}).join(",")
			},
			getSecondText(value) {
				return value.map(item => {
					return item.userInfo.nickname
				}).join(",")
			},
			getThirdText(value) {
				return value.map(item => {
					return item.userInfo.nickname
				}).join(",")
			}
		},
		methods: {
			setDefaultValue() {
				this.yt.editObj.status = 1;
			},
			getExceptionType() {
				this.http.get('/web/andon/exceptionType/page', {
					params: {
						pageNum: 1,
						pageSize: 1000
					}
				}).then(res => {
					this.exceptionTypeList = res.data.rows
				})

			}
		}
	};
</script>
